import { TransactionStatus } from '@api/izibizi-xp';
import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useTheme } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { Check, Pending } from '@bcp-nextgen-dx-component-factory/accolade-design-system/dist/assets/MBCP/icons';
import { rem } from '@helpers';
import { useSelectedPlan, useServiceResponse } from '@store';

type SubscriptionStatus = 'success' | 'pending';

type SettingsByStatus = {
	[key in SubscriptionStatus]: {
		iconBgColor: string;
		icon: React.ReactNode;
		statusDescription: string;
	};
};

interface MembershipCompletionTitleHelperOutput {
	icon: React.ReactNode;
	iconBgColor: string;
	statusDescription: string;
	selectedPlanName: string;
}

export const useMembershipCompletionTitleHelper = (): MembershipCompletionTitleHelperOutput => {
	const t = useTranslation();
	const { palette } = useTheme();
	const { subscriptionMaintenance } = useServiceResponse();

	const status: SubscriptionStatus =
		subscriptionMaintenance?.transactionStatus === TransactionStatus.OK ? 'success' : 'pending';
	const selectedPlan = useSelectedPlan();

	const settingsByStatus: SettingsByStatus = {
		success: {
			iconBgColor: palette.global.ui21,
			icon: <Check fill={palette.global.ui18} width={rem(45)} height={rem(45)} />,
			statusDescription: t('placeholders.subscriptionConclusion.statusDescription.successfulSubscription'),
		},
		pending: {
			iconBgColor: palette.global.ui49,
			icon: <Pending fill={palette.global.ui18} width={rem(45)} height={rem(45)} />,
			statusDescription: t('placeholders.subscriptionConclusion.statusDescription.pendingSubscription'),
		},
	};

	const { icon, iconBgColor, statusDescription } = settingsByStatus[status];

	const selectedPlanName = t('placeholders.costSummary.title', { planName: selectedPlan?.name });

	return {
		icon,
		iconBgColor,
		statusDescription,
		selectedPlanName,
	};
};
